import produce from 'immer';

import {
  FETCH_READERS,
  FETCH_READERS_SUCCESS,
  FETCH_USERS_FOR_SPECIFIC_ROLE,
  FETCH_USERS_FOR_SPECIFIC_ROLE_FAILED,
  FETCH_USERS_FOR_SPECIFIC_ROLE_SUCCESS,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_FAILED,
  FORGOT_PASSWORD_SUCCESS,
  INITIAL_LOAD_USER_DONE,
  RESET_PASSWORD,
  RESET_PASSWORD_FAILED,
  RESET_PASSWORD_SUCCESS,
  RESET_STATE,
  SEARCH_USERS,
  SEARCH_USERS_SUCCESS,
  SIGNIN,
  SIGNIN_FAILED,
  SIGNIN_SUCCESS,
  SIGNOUT,
  SIGNUP,
  SIGNUP_FAILED,
  SIGNUP_SUCCESS,
  UPDATE_STATUS,
  UPDATE_USER,
  UPDATE_USER_FAILED,
  UPDATE_USER_SUCCESS,
} from 'actions/userActions';

// The initial state of the App
export const initialState = {
  signingIn: false,
  signinSuccess: false,
  signinFailed: false,
  statusText: null,
  signingUp: false,
  signupSuccess: false,
  signupFailed: false,
  fetchingUser: false,
  fetchUserSuccess: false,
  fetchingUserFailed: false,
  initialLoadUserDone: false,
  createdUser: null,
  usersList: [],
  reseting: false,
  resetSuccess: false,
  resetFail: false,
  resetError: '',
  readers: [],
  pageNumberBack: -1,
  total: 0,
  statuses: {},
  submitting: false,
  createSuccess: false,
  createFailed: false,
  createError: '',
  itemId: null,
};

/* eslint-disable default-case, no-param-reassign */
const userReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SIGNIN:
        draft.signingIn = true;
        draft.signinSuccess = false;
        draft.signinFailed = false;
        break;

      case SIGNIN_SUCCESS:
        draft.signingIn = false;
        draft.signinSuccess = true;
        draft.signinFailed = false;
        // Add all properties of the signin response to the root level of state

        Object.assign(draft, action.user);
        break;

      case SIGNIN_FAILED:
        draft.signingIn = false;
        draft.signinSuccess = false;
        draft.signinFailed = true;
        draft.statusText = action.err;
        break;

      case SIGNUP:
        draft.signingUp = true;
        draft.signupSuccess = false;
        draft.signupFailed = false;
        break;

      case SIGNUP_SUCCESS:
        draft.signingUp = false;
        draft.signupSuccess = true;
        draft.signupFailed = false;
        draft.createdUser = action.user;
        break;

      case SIGNUP_FAILED:
        draft.signingUp = false;
        draft.signupSuccess = false;
        draft.signupFailed = true;
        draft.statusText = action.error;
        break;

      case INITIAL_LOAD_USER_DONE:
        draft.initialLoadUserDone = true;
        Object.assign(draft, action.user);
        break;

      case SIGNOUT:
        // eslint-disable-next-line no-case-declarations
        const newState = initialState;
        newState.initialLoadUserDone = true;
        return newState;

      case UPDATE_USER:
        draft.submitting = true;
        draft.createSuccess = false;
        draft.createFailed = false;
        draft.statusText = '';
        break;

      case UPDATE_USER_SUCCESS:
        draft.submitting = false;
        draft.createSuccess = true;
        draft.createFailed = false;
        draft.statusText = '';
        break;

      case UPDATE_USER_FAILED:
        draft.submitting = false;
        draft.createSuccess = false;
        draft.createFailed = true;
        draft.statusText = action.err;
        draft.itemId = action.id;
        break;

      case UPDATE_STATUS:
        draft.submitting = false;
        draft.statusText = '';
        draft.createSuccess = false;
        draft.createFailed = false;
        break;

      case RESET_STATE:
        draft.signingIn = false;
        draft.signinSuccess = false;
        draft.signinFailed = false;
        draft.statusText = null;
        draft.signingUp = false;
        draft.createdUser = null;
        draft.reseting = false;
        draft.resetFail = false;
        draft.resetSuccess = false;
        draft.resetError = '';
        break;

      case SEARCH_USERS:
        draft.usersList = [];
        break;
      case SEARCH_USERS_SUCCESS:
        break;

      case FETCH_USERS_FOR_SPECIFIC_ROLE:
        draft.fetchingUser = true;
        draft.fetchUserSuccess = false;
        draft.fetchingUserFailed = false;
        break;
      case FETCH_USERS_FOR_SPECIFIC_ROLE_SUCCESS:
        draft.fetchingUser = false;
        draft.fetchUserSuccess = true;
        draft.fetchingUserFailed = false;
        draft.usersList = action.result.users;
        draft.pageNumberBack = action.result.pageNumberBack;
        draft.total = action.result.total;
        draft.statuses = action.result.statuses;
        break;
      case FETCH_USERS_FOR_SPECIFIC_ROLE_FAILED:
        draft.fetchingUser = false;
        draft.fetchUserSuccess = false;
        draft.fetchingUserFailed = true;
        break;

      case FORGOT_PASSWORD:
      case RESET_PASSWORD:
        draft.reseting = true;
        draft.resetFail = false;
        draft.resetSuccess = false;
        draft.resetError = '';
        break;

      case FORGOT_PASSWORD_SUCCESS:
      case RESET_PASSWORD_SUCCESS:
        draft.reseting = false;
        draft.resetFail = false;
        draft.resetSuccess = true;

        break;

      case FORGOT_PASSWORD_FAILED:
        draft.reseting = false;
        draft.resetFail = true;
        draft.resetSuccess = false;
        draft.resetError = 'We cannot found user with this email address';
        break;

      case RESET_PASSWORD_FAILED:
        draft.reseting = false;
        draft.resetFail = true;
        draft.resetSuccess = false;
        draft.resetError = action.error;
        break;

      case FETCH_READERS:
        draft.fetchingUser = true;
        draft.fetchUserSuccess = false;

        break;
      case FETCH_READERS_SUCCESS:
        draft.fetchingUser = false;
        draft.fetchUserSuccess = true;
        draft.readers = action.user;
        break;
    }
  });

export default userReducer;
